import { defineStore } from 'pinia'

export default defineStore({
  id: 'dataTable',
  persist: true,
  state: () => {
    return {
      isArchive: false
    }
  },
  actions: {
    setIsArchive: function (payload: boolean) {
      this.isArchive = payload
    }
  },
  getters: {
    getIsArchive: (state: any) => state.isArchive
  }
})
